{
	"title": "Medal tally",
	"subtitle": "{{games}}. Ranked by gold, then silver, then bronze; tied NOCs share a rank. Open a NOC for its medals.",
	"range": "{{from}} to {{to}}",
	"asOf": "As of {{time}}",
	"csv": {
		"code": "Code"
	},
	"view": {
		"label": "View",
		"table": "Table",
		"bars": "Bars",
		"heatmap": "Heatmap"
	},
	"actions": {
		"csv": "Export CSV",
		"print": "Print",
		"tv": "TV mode"
	},
	"filters": {
		"gender": "Gender",
		"from": "Awarded from",
		"until": "Until",
		"today": "Today only",
		"clear": "Clear filters"
	},
	"gender": {
		"all": "All events",
		"MEN": "Men",
		"WOMEN": "Women",
		"MIXED": "Mixed",
		"OPEN": "Open"
	},
	"table": {
		"rank": "Rank",
		"noc": "NOC",
		"total": "Total",
		"mix": "Medals",
		"trend": "By day",
		"open": "Show the medals of {{noc}}"
	},
	"summary": {
		"label": "Tally summary",
		"leader": "Leader",
		"tied": "Tied for the lead",
		"noLeader": "No medal awarded yet",
		"medals": "Medals awarded",
		"nocs": "NOCs with a medal",
		"ofTotal": "{{n}} of {{total}}",
		"nocsDetail": "Every NOC taking part is on the tally, zeros included.",
		"events": "Medal events decided",
		"eventsAll": "Awarded or settled with no medals, whole programme",
		"eventsSport": "Awarded or settled with no medals, this sport"
	},
	"bars": {
		"title": "Medals by NOC",
		"description": "Gold, silver and bronze on one scale."
	},
	"heatmap": {
		"title": "NOC by sport",
		"description": "Medals of each NOC in each sport that has awarded one. Hover a cell for its colours."
	},
	"tv": {
		"rotate": "Rotate the views",
		"hint": "Refreshes every 30 seconds. Press Esc to leave.",
		"exit": "Leave TV mode"
	},
	"drawer": {
		"totals": "Totals",
		"rank": "Rank",
		"ofNocs": "of {{n}} NOCs",
		"bySport": "Medals by sport",
		"byDay": "Medals by day",
		"medals": "Every medal",
		"none": "No medal yet."
	}
}
